import { DateTime } from "luxon";

export const formatRelativeDate = (isoDateString) => {
  if (!isoDateString) return "";

  const now = DateTime.local();
  const date = DateTime.fromISO(isoDateString);

  const isToday = date.hasSame(now, "day");
  const isYesterday = date.hasSame(now.minus({ days: 1 }), "day");
  const daysAgo = Math.floor(now.diff(date, "days").days);

  if (isToday) {
    return `Today at ${date.toFormat("h:mma")}`;
  }

  if (isYesterday) {
    return `Yesterday at ${date.toFormat("h:mma")}`;
  }

  if (daysAgo < 7) {
    return `${date.toFormat("cccc")} at ${date.toFormat("h:mma")}`;
  }

  const includeYear = !date.hasSame(now, "year");
  return date.toFormat(includeYear ? "MMMM d, yyyy" : "MMMM d");
};
